










































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import PayPalPlanDTO from '@/dto/subscription/PayPalPlanDTO';
import PortalDictionaryDTO from '@/dto/common/PortalDictionaryDTO';
import UserSummary from '@/dto/profile/UserSummary';
import { SubscriberType } from '@/constants/SubscriptionConstants';
import SubscriptionService from '@/services/SubscriptionService';
import { processError } from '@/utils/ComponentUtils';
import Clipboard from '@/state/Clipboard';

@Component({})
export default class SubscriptionsAdminModal extends Vue {
  @Prop({ required: true, type: Array }) readonly planGroups!: Array<{ group: PortalDictionaryDTO; plans: Array<PayPalPlanDTO> }>;
  @Prop({ required: true }) readonly userSummary!: UserSummary | null;

  selectedPlan: PayPalPlanDTO | null = null;
  selectedPersonId: number | null = null;
  selectedCompanyIds: number[] = [];
  sendLinkToCustomer = true;

  creating = false;
  approveLink: string | null = null;
  validationErrors: string[] = [];

  onSelectPlan(plan: PayPalPlanDTO) {
    this.selectedPlan = plan;
    this.approveLink = null;
    if (this.selectedPlanRequiresPerson) {
      this.selectedCompanyIds = [];
    }
    if (this.selectedPlanRequiresCompany) {
      this.selectedPersonId = null;
    }
  }

  get selectedPlanRequiresPerson(): boolean {
    return !!this.selectedPlan && this.selectedPlan.subscriberType === SubscriberType.PERSON;
  }

  get selectedPlanRequiresCompany(): boolean {
    return !!this.selectedPlan && this.selectedPlan.subscriberType === SubscriberType.COMPANY;
  }

  togglePerson(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!this.userSummary || !this.userSummary.person) return;
    if (input.checked) {
      this.selectedPersonId = this.userSummary.person.id;
    } else {
      this.selectedPersonId = null;
    }
  }

  selectAllCompanies() {
    if (!this.userSummary) return;
    if (this.selectedPlanRequiresPerson) return;
    this.selectedCompanyIds = this.userSummary.companies.map(c => c.id);
  }

  clearCompanies() {
    this.selectedCompanyIds = [];
  }

  get isValid(): boolean {
    this.validationErrors = [];
    if (!this.selectedPlan) {
      this.validationErrors.push('Plan is required');
    }
    const hasPerson = this.selectedPersonId != null;
    const hasCompanies = this.selectedCompanyIds.length > 0;

    if (this.selectedPlanRequiresPerson) {
      if (!hasPerson) this.validationErrors.push('Person must be selected for this plan');
      if (hasCompanies) this.validationErrors.push('Companies are not allowed for this plan');
    } else if (this.selectedPlanRequiresCompany) {
      if (!hasCompanies) this.validationErrors.push('At least one company must be selected for this plan');
      if (hasPerson) this.validationErrors.push('Person is not allowed for this plan');
    } else {
      if (!hasPerson && !hasCompanies) this.validationErrors.push('Select at least one profile (person or company)');
    }

    return this.validationErrors.length === 0;
  }

  async createSubscription() {
    if (!this.isValid || !this.selectedPlan) return;
    this.creating = true;
    try {
      const resp = await SubscriptionService.createPayPalSubscriptionAdmin(
        this.selectedPlan.id,
        this.selectedCompanyIds,
        this.selectedPersonId,
        this.sendLinkToCustomer
      );
      this.approveLink = resp.data;
      this.$emit('created', this.approveLink);
    } catch (e) {
      processError(this, e);
    } finally {
      this.creating = false;
    }
  }

  copyApproveLink() {
    if (!this.approveLink) return;
    Clipboard.write(this.approveLink);
  }
}
